export enum Languages {
  EN = 'en',
  ES = 'es',
  PT = 'pt'
}
